import * as React from "react";
import * as Glob from "../Globale";
import { BasePureComponent } from "./BaseComponent";
import * as Dati from "../Dati";
import { Trad } from "../components/";
import { InputCheckBox } from "../components/";

//JSON Parametri esempio
/*
{
    DomandaAperturaQuestionario: string;
    PopolamentoInfoSu: boolean(true / false);
    NumeroMassimoRecord: number(1, n);
    DatiQuestionario:
    [
        {
            Campo: string,
            Etichetta: string,
            ID_TipoCampo: number,
            DimensioneGrafica: number
        },
        {
            Campo: string,
            Etichetta: string,
            ID_TipoCampo: number,
            DimensioneGrafica: number
        }
    ]
}
*/
//{"DomandaAperturaQuestionario": "Il proponente, negli ultimi 5 anni, ha stipulato coperture assicurative per questa tipologia di rischio?","PopolamentoInfoSu": true,"NumeroMassimoRecord": 5,"DatiQuestionario": [{"Campo": "Compagnia","Etichetta": "Compagnia","ID_TipoCampo": 2,"DimensioneGrafica": 11}, {"Campo": "DataDiInizio","Etichetta": "DataDiInizio","ID_TipoCampo": 3,"DimensioneGrafica": 3}, {"Campo": "DataDiScadenza","Etichetta": "DataDiScadenza","ID_TipoCampo": 3,"DimensioneGrafica": 3}, {"Campo": "Massimale","Etichetta": "Massimale","ID_TipoCampo": 9,"DimensioneGrafica": 3}, {"Campo": "Retroattivita","Etichetta": "Retroattivita","ID_TipoCampo": 1,"DimensioneGrafica": 3}, {"Campo": "PremioPagato","Etichetta": "PremioPagato","ID_TipoCampo": 9,"DimensioneGrafica": 3}, {"Campo": "NumeroAnniCoperturaPrecedenteContinua","Etichetta": "NumeroAnniCoperturaPrecedenteContinua","ID_TipoCampo": 2,"DimensioneGrafica": 3}, {"Campo": "RifiutoCopertureAssicurative","Etichetta": "RifiutoCopertureAssicurative","ID_TipoCampo": 5,"DimensioneGrafica": 12}, {"Campo": "DettagliRifiutoCopertureAssicurative","Etichetta": "DettagliRifiutoCopertureAssicurative","ID_TipoCampo": 2,"DimensioneGrafica": 11}, {"Campo": "ContrattiInVigore","Etichetta": "ContrattiInVigore","ID_TipoCampo": 2,"DimensioneGrafica": 11}]}

//JSON Dati esempio
/*
{
    RispostaAperturaQuestionario: boolean;
    DatiQuestionario:
    [
        {
            Campo: string,
            Valore: any
        },
        {
            Campo: string,
            Valore: any
        }
    ]
}
*/

//{"RispostaAperturaQuestionario": false, "DatiQuestionario": []}

export class CCampiMultiInfoStruttura {
    DomandaAperturaQuestionario: string = "";
    PopolamentoInfoSu: boolean = true;
    NumeroMassimoRecord: number = 1;
    DatiQuestionario: Dati.CCampoStruttura[] = [];
    Grafica: string = "";
}

export class CCampiMultiInfoDati {
    RispostaAperturaQuestionario: boolean = false;
    //DatiQuestionario: Dati.CCampoDato[][] = [];
    DatiQuestionario: Dati.CDictionary<any>[] = [];
}

interface ICampoMultiInfoProps extends Dati.IBaseProps {
    Valori: Glob.DatiJSON; //JSON
    Parametri: Glob.DatiJSON; //JSON
}

export class CampoMultiInfo extends BasePureComponent<ICampoMultiInfoProps, {}> {
    private _Parametri: CCampiMultiInfoStruttura = new CCampiMultiInfoStruttura();
    private _Valori: CCampiMultiInfoDati = new CCampiMultiInfoDati();
    private _Collassato: string = "";
    private _Visualizza = "";
    private _TabAttivo: number = 1; //0 se vogliamo che parta chiuso

    constructor(props: any) {
        super(props);
        this.OnAggiorna = this.OnAggiorna.bind(this);
    }

    private Inizializza(props: ICampoMultiInfoProps) {
        if (typeof props.Parametri == "string") {
            this._Parametri = JSON.parse(props.Parametri);
        } else {
            this._Parametri = props.Parametri;
        }

        this.PopolaValori(props.Valori);
    }

    private PopolaValori(valore: any | string) {
        if (valore != undefined && valore != "") {
            if (typeof valore == "string") {
                this._Valori = JSON.parse(valore);
                //console.warn("ENTRATOA", this.props.Name, this._Valori, valore);
            } else {
                this._Valori = new CCampiMultiInfoDati();
                this._Valori.RispostaAperturaQuestionario = valore.RispostaAperturaQuestionario;
                for (let i: number = 0; i < valore.DatiQuestionario.length; i++) {
                    let dati: Dati.CDictionary<any> = new Dati.CDictionary<any>();
                    dati.LoadFromJSON(JSON.stringify(valore.DatiQuestionario[i].items));
                    this._Valori.DatiQuestionario.push(dati);
                }
                //console.warn("ENTRATOB", this.props.Name, this._Valori, valore);
            }
        } else {
            this._Valori = new CCampiMultiInfoDati();
            //console.warn("ENTRATOC", this.props.Name, this._Valori, valore);
        }

        if (this._Valori.DatiQuestionario.length <= 0) {
            this.Aggiungi();
        }

        if (this._Valori.RispostaAperturaQuestionario != undefined && this._Valori.RispostaAperturaQuestionario) {
            this._Collassato = "";
            this._Visualizza = "show";
        } else {
            this._Collassato = "collapsed";
            this._Visualizza = "";
        }
    }

    private VisualizzaDati(): React.ReactNode {
        let dati: React.ReactNode[] = [];
        let gruppo: React.ReactNode[] = [];
        for (let i: number = 0; i < this._Valori.DatiQuestionario.length; i++) {
            for (let x: number = 0; x < this._Valori.DatiQuestionario[i].Keys().length; x++) {
                let dato: Dati.CCampoDato = new Dati.CCampoDato();
                dato.Campo = this._Valori.DatiQuestionario[i].Keys()[x];
                dato.Valore = this._Valori.DatiQuestionario[i].Item(dato.Campo);
                //this._Parametri.DatiQuestionario.filter(p => p.Campo == this._Valori.DatiQuestionario[i].Keys()[x])[0].Etichetta = Trad.Trad(this._Parametri.DatiQuestionario.filter(p => p.Campo == this._Valori.DatiQuestionario[i].Keys()[x])[0].Etichetta);
                this._Parametri.DatiQuestionario.filter(p => p.Campo == this._Valori.DatiQuestionario[i].Keys()[x])[0].Etichetta = this._Parametri.DatiQuestionario.filter(
                    p => p.Campo == this._Valori.DatiQuestionario[i].Keys()[x]
                )[0].Etichetta;
                gruppo.push(
                    Glob.GetComponente(
                        (i + "_" + x).toString(),
                        this._Parametri.DatiQuestionario.filter(p => p.Campo == this._Valori.DatiQuestionario[i].Keys()[x])[0],
                        dato,
                        this.OnAggiorna,
                        this._Valori.DatiQuestionario[i]
                    )
                );
            }
            gruppo.push(<div key={"spazio-" + i} className={Glob.DimensioneCSS(10)}></div>);
            if (this._Parametri.NumeroMassimoRecord > 1) {
                gruppo.push(
                    <div key={i} className={Glob.DimensioneCSS(2)}>
                        <input type="button" className="btn btn-danger prettybtn" name={i.toString()} value={Trad.Trad("Elimina")} onClick={e => this.OnElimina(e)} />
                    </div>
                );
            }
            dati.push(
                <div key={"dati-" + i} className="form-group kt-form login-form__group row dashedborder">
                    {gruppo}
                </div>
            );
            gruppo = [];
        }

        return dati;
    }

    private OnElimina(e: React.FormEvent<any>): void {
        let indice: number = Number(e.currentTarget.name);
        this._Valori.DatiQuestionario.splice(indice, 1);
        this._TabAttivo = 1;
        this.props.OnChange(this.props.Name, this._Valori);
    }

    private Aggiungi(): void {
        if (this._Valori.DatiQuestionario.length < this._Parametri.NumeroMassimoRecord) {
            let RecordZero: Dati.CDictionary<any> = new Dati.CDictionary<any>();
            for (let i: number = 0; i < this._Parametri.DatiQuestionario.length; i++) {
                RecordZero.Add(this._Parametri.DatiQuestionario[i].Campo, "");
            }
            this._Valori.DatiQuestionario.push(RecordZero);
        } else {
            Glob.InfoModaleWarning("WARNING", Trad.Trad("NumeroMassimoInformazioniInseribiliRaggiunto"));
        }
    }

    private OnAggiungi(): any {
        this.Aggiungi();
        this._TabAttivo = this._Valori.DatiQuestionario.length;
        this.props.OnChange(this.props.Name, this._Valori);
        return true;
    }

    private OnAggiorna(e: React.FormEvent<any> | string, valore: any): void {
        if (typeof e == "string") {
            let indici: string[] = e.split("_");
            let i: number = 0;
            let x: number = 0;
            i = Number(indici[indici.length - 2]);
            x = Number(indici[indici.length - 1]);
            //this._Valori.DatiQuestionario[i][x].Valore = valore;
            this._Valori.DatiQuestionario[i].Set(this._Valori.DatiQuestionario[i].Keys()[x], valore);
        } else {
            let i: number = 0;
            let x: number = 0;
            if (e.currentTarget.name != this.props.Name) {
                let indici: string[] = e.currentTarget.name.split("_");
                i = Number(indici[indici.length - 2]);
                x = Number(indici[indici.length - 1]);
            }

            if ((e.currentTarget as HTMLInputElement).type == "checkbox" && e.currentTarget.name == this.props.Name) {
                this._Valori.RispostaAperturaQuestionario = e.currentTarget.checked;
            } else if ((e.currentTarget as HTMLInputElement).type == "checkbox" && e.currentTarget.name != this.props.Name) {
                this._Valori.DatiQuestionario[i].Set(this._Valori.DatiQuestionario[i].Keys()[x], e.currentTarget.checked);
            } else if ((e.currentTarget as HTMLInputElement).type == "radio" && e.currentTarget.name == this.props.Name) {
                this._Valori.RispostaAperturaQuestionario = e.currentTarget.value.toUpperCase() == "TRUE" || e.currentTarget.value == true ? true : false;
            } else if ((e.currentTarget as HTMLInputElement).type == "radio" && e.currentTarget.name != this.props.Name) {
                this._Valori.DatiQuestionario[i].Set(this._Valori.DatiQuestionario[i].Keys()[x], e.currentTarget.value.toUpperCase() == "TRUE" || e.currentTarget.value == true ? true : false);
            }
            if (!this._Valori.RispostaAperturaQuestionario) {
                this._Valori = new CCampiMultiInfoDati();
            }
        }

        this.props.OnChange(this.props.Name, this._Valori);
    }

    private VisualizzazioneTab(): React.ReactNode {
        let dati: any[] = [];
        let gruppo: any = [];

        let Tabs: any[] = [];
        let IndiceGruppo: number = 0;
        let app: Dati.CDictionary<any>[];
        for (let i: number = 0; i < this._Valori.DatiQuestionario.length; i++) {
            IndiceGruppo = i + 1;
            for (let x: number = 0; x < this._Valori.DatiQuestionario[i].Keys().length; x++) {
                let dato: Dati.CCampoDato = new Dati.CCampoDato();
                dato.Campo = this._Valori.DatiQuestionario[i].Keys()[x];
                dato.Valore = this._Valori.DatiQuestionario[i].Item(dato.Campo);
                gruppo.push(
                    Glob.GetComponente(
                        (i + "_" + x).toString(),
                        this._Parametri.DatiQuestionario.filter(p => p.Campo == this._Valori.DatiQuestionario[i].Keys()[x])[0],
                        dato,
                        this.OnAggiorna,
                        this._Valori.DatiQuestionario[i]
                    )
                ); //Inserisco sempre i campi nel gruppo
                if (x == 0) {
                    Tabs.push(
                        <li className="nav-item" key={i}>
                            <a
                                className={"nav-link " + this.TabAttivo(IndiceGruppo)}
                                data-toggle="tab"
                                data-indice={IndiceGruppo}
                                href={"#kt_tabs_" + this.props.Name + "_" + IndiceGruppo}
                                onClick={e => {
                                    this.OnClickTab(e);
                                }}
                            >
                                <i className="flaticon-information"></i>
                                <span className="kt--visible-desktop-inline-block">{String(this._Valori.DatiQuestionario[i].Item(this._Valori.DatiQuestionario[i].Keys()[x]))}</span>
                            </a>
                        </li>
                    );
                }
            }
            if (this._Parametri.NumeroMassimoRecord > 1) {
                gruppo.push(
                    <div key={i} className={Glob.DimensioneCSS(1)}>
                        <input type="button" className="btn btn-danger prettybtn" name={i.toString()} value={Trad.Trad("Elimina")} onClick={e => this.OnElimina(e)} />
                    </div>
                );
            }
            gruppo.push(<div key={"spazio-" + i} className={Glob.DimensioneCSS(11)}></div>);
            dati.push(
                <div className={"tab-pane " + this.TabAttivo(IndiceGruppo)} id={"kt_tabs_" + this.props.Name + "_" + i + 1} role="tabpanel" key={i}>
                    <div className="form-group kt-form login-form__group row" key={"dati-" + i}>
                        {gruppo}
                    </div>
                </div>
            );
            gruppo = [];
        }

        return (
            <div className="kt-portlet">
                <div className="kt-portlet__body">
                    <ul className="nav nav-tabs" role="tablist">
                        {Tabs}
                        {this._Parametri.NumeroMassimoRecord > 1 && (
                            <a className="nav-link" data-toggle="tab" onClick={() => this.OnAggiungi()}>
                                <i className="flaticon-add kt--font-info"></i>
                                <span className="kt--visible-desktop-inline-block"></span>
                            </a>
                        )}
                        <a className="nav-link" data-toggle="tab" onClick={() => this.ApriChiudi()}>
                            <i className={this.IconaApriChiudi()} title={this.TitleApriChiudi()}></i>
                            <span className="kt--visible-desktop-inline-block"></span>
                        </a>
                    </ul>
                    <div className="tab-content">{dati}</div>
                </div>
            </div>
        );
    }

    private OnClickTab(e: React.FormEvent<any>) {
        //if (this._TabAttivo != e.currentTarget.getAttribute('data-indice')) { //Possibilità di chiudere il tab
        //    this._TabAttivo = e.currentTarget.getAttribute('data-indice');
        //} else {
        //    this._TabAttivo = 0;
        //}
        this._TabAttivo = e.currentTarget.getAttribute("data-indice");
        this.forceUpdate();
    }

    private TabAttivo(indice: number): string {
        if (indice == this._TabAttivo) {
            return "active";
        } else {
            return "";
        }
    }

    private IconaApriChiudi(): string {
        if (this._TabAttivo == 0) {
            return "flaticon-folder-1 kt--font-success";
        } else {
            return "flaticon-folder kt--font-warning";
        }
    }

    private TitleApriChiudi(): string {
        if (this._TabAttivo == 0) {
            return Trad.Trad("EspandiInfo");
        } else {
            return Trad.Trad("ComprimiInfo");
        }
    }

    private ApriChiudi() {
        if (this._TabAttivo == 0) {
            this._TabAttivo = 1;
        } else {
            this._TabAttivo = 0;
        }

        this.forceUpdate();
    }

    private SelezioneGrafica(): React.ReactNode {
        switch (this._Parametri.Grafica) {
            case "Tab": {
                return this.VisualizzazioneTab();
            }
            default: {
                return this.VisualizzazioneStandard();
            }
        }
    }

    private VisualizzazioneStandard(): React.ReactNode {
        return (
            <div className="kt-accordion__itekt-content">
                {this.VisualizzaDati()}
                {this._Parametri.NumeroMassimoRecord > 1 && (
                    <div className="form-group kt-form login-form__group row">
                        <div className={Glob.DimensioneCSS(1)}>
                            <input type="button" className="btn btn-brand" value={Trad.Trad("Aggiungi")} onClick={() => this.OnAggiungi()} />
                        </div>
                        <div className={Glob.DimensioneCSS(11)}></div>
                    </div>
                )}
            </div>
        );
    }

    public render() {
        let Testata: any = (
            <div className={"kt-accordion__item-head " + this._Collassato} id={"H_" + this.props.Id}>
                <label>{Trad.Trad(this._Parametri.DomandaAperturaQuestionario)}</label>
                <div className="kt-radio-inline">
                    <label className={`kt-radio${this._Valori.RispostaAperturaQuestionario ? " kt-radio--brand" : ""}`}>
                        <input
                            type="radio"
                            name={this.props.Name}
                            value={"True"}
                            checked={this._Valori.RispostaAperturaQuestionario}
                            onChange={e => this.OnAggiorna(e as React.FormEvent<any>, undefined)}
                        />{" "}
                        {Trad.Trad("SI")}
                        <span></span>
                    </label>
                    <label className={`kt-radio${!this._Valori.RispostaAperturaQuestionario ? " kt-radio--brand" : ""}`}>
                        <input
                            type="radio"
                            name={this.props.Name}
                            value={"False"}
                            checked={!this._Valori.RispostaAperturaQuestionario}
                            onChange={e => this.OnAggiorna(e as React.FormEvent<any>, undefined)}
                        />{" "}
                        {Trad.Trad("NO")}
                        <span></span>
                    </label>
                </div>
            </div>
        );

        if (this._Parametri.Grafica != undefined && this._Parametri.Grafica == "CheckBox") {
            Testata = (
                <div className={"kt-accordion__item-head " + this._Collassato} id={"H_" + this.props.Id}>
                    <InputCheckBox
                        Name={this.props.Name}
                        Id={this.props.Id}
                        Etichetta={this._Parametri.DomandaAperturaQuestionario}
                        Valore={this._Valori.RispostaAperturaQuestionario}
                        OnChange={e => this.OnAggiorna(e as React.FormEvent<any>, undefined)}
                    />
                </div>
            );
        }
        this.Inizializza(this.props);
        return (
            <div key={this.props.Id} className="kt-accordion kt-accordion--default" id={"kt_accordion_" + this.props.Id} role="tablist">
                <div className="kt-accordion__item">
                    {Testata}
                    <div
                        className={"kt-accordion__itekt-body collapse " + this._Visualizza}
                        id={"kt_accordion_" + this.props.Id + "_item_1_body"}
                        role="tabpanel"
                        aria-labelledby={"kt_accordion_" + this.props.Id + "_item_1_head"}
                    >
                        {this.SelezioneGrafica()}
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/CampoMultiInfo.tsx